import { Component, OnInit, OnDestroy }  from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import {ITowersTraconsImport} from './towers-tracons-import';
import {TowersTraconsImportService} from './towers-tracons-import.service';
import {towersTraconsImportPipe} from './towers-tracons-import.pipe';

import {DataTable} from 'primeng/primeng';
import {Column} from 'primeng/primeng';
import {Header} from 'primeng/primeng';


@Component({
    //templateUrl: 'app/system-management/towers-tracons-import/towers-tracons-import.component.html',
    template: require('./towers-tracons-import.component.html'),
    directives: [ROUTER_DIRECTIVES,DataTable,Column, Header],
    providers: [TowersTraconsImportService]
})
export class TowersTraconsImportComponent implements OnInit, OnDestroy{
    pageTitle: string = 'Towers Tracons OPSNET Import Check ';
    errorMessage: string;
    private sub: any;
    cols: any[];
    cols1: any[];
    cols2: any[];
    towersImportResult:ITowersTraconsImport;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private _towerstraconsImportService: TowersTraconsImportService){
    }

   ngOnInit(): void{
            this._towerstraconsImportService.getTowersImport()
            .subscribe(
                towersImportResult => this.towersImportResult = towersImportResult,
                error =>  this.errorMessage = <any>error);
         this.cols = [
            {field: "opsAc", header: 'OPSNET Air Carrier'},
            {field: "opsAt", header: 'OPSNET Air Taxi'},
            {field: "opsGa", header: 'OPSNET General Aviation'},
            {field: "opsMil", header: 'OPSNET Military'},
            {field: "opsLocGa", header: 'OPSNET Civil'},
            {field: "opsLocMil", header: 'OPSNET Local Military'},
            {field: "opsTotOvers", header: 'OPSNET Total Overflights'},
        ]
         this.cols1 = [
            {field: "tafAc", header: 'TAF Air Carrier'},
            {field: "tafAt", header: 'TAF Air Taxi'},
            {field: "tafGa", header: 'TAF General Aviation'},
            {field: "tafMil", header: 'TAF Military'},
            {field: "tafLocGa", header: 'TAF Civil'},
            {field: "tafLocMil", header: 'TAF Local Military'},
            {field: "tafTotOvers", header: 'TAF Total Overflights'},
        ]
        this.cols2 = [
            {field: "diffAc", header: 'DIFF Air Carrier'},
            {field: "diffAt", header: 'DIFF Air Taxi'},
            {field: "diffGa", header: 'DIFF General Aviation'},
            {field: "diffMil", header: 'DIFF Military'},
            {field: "diffLocGa", header: 'DIFF Civil'},
            {field: "diffLocMil", header: 'DIFF Local Military'},
            {field: "diffTotOvers", header: 'DIFF Total Overflights'},
        ]
   }
   ngOnDestroy() {
        //alert("onDestroy");
        //this.sub.unsubscribe();
   }
}


/** WEBPACK FOOTER **
 ** ./app/system-management/towers-tracons-import/towers-tracons-import.component.ts
 **/